import React, { useEffect, useState } from "react";
import { Code, Tooltip } from "@mantine/core";
import moment from "moment";

const SystemClock = () => {
  const [now, setNow] = useState(() => moment());

  useEffect(() => {
    const interval = setInterval(() => setNow(moment()), 1000);
    return () => clearInterval(interval);
  }, []);

  const display = now.format("YYYY-MM-DD HH:mm:ss");

  return (
    <Tooltip
      label={now.clone().locale("en").format("dddd, YYYY-MM-DD HH:mm:ss")}
      withArrow
      position="bottom"
    >
      <Code
        sx={{
          fontWeight: 700,
          cursor: "default",
          whiteSpace: "nowrap",
        }}
      >
        {display}
      </Code>
    </Tooltip>
  );
};

export default SystemClock;
